<template>
  <div :class="$style.container">
    <RichText v-if="item.day" :text-params="item.day" :class="$style.day" />
    <div :class="[$style.iconBg, { [$style.isSkip]: isSkip }]">
      <PImage v-if="item.icon" :class="$style.icon" :image-object="item.icon" />
    </div>
    <RichText
      v-if="item.description"
      :text-params="item.description"
      :class="$style.description"
    />
  </div>
</template>

<script>
import RichText from '~/components/RichText'

export default {
  name: 'LukonTerminationDayStep',

  components: {
    RichText,
  },

  props: {
    item: {
      type: Object,
      required: true,
    },
  },

  computed: {
    isSkip() {
      return !this.item.day?.length
    },
  },
}
</script>

<style lang="scss" module>
.container {
  display: flex;
  align-items: center;
}

.day {
  @include typo-sub-text;
  min-width: 42px;
  margin-right: 16px;

  color: $bluko-200;
}
.iconBg {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  min-width: 48px;
  height: 48px;
  min-height: 48px;
  margin-right: 16px;

  border-radius: 50%;

  background-color: $bluko-50;
}

.icon {
  width: 20px;
  height: 24px;
}

.isSkip {
  margin-left: 55px;

  background-color: transparent !important;
}

.description {
  color: $gray-700;
  strong {
    color: $gray-1000;
  }
}
</style>
